<div #pageContainer class="w-full">
    <div class="grid overflow-x-auto">
        <!-- Header -->
        <div class="table-annulus-pressure-pi-record-list-grid z-10 sticky top-0 grid shadow text-md font-semibold text-white bg-primary dark:bg-black dark:bg-opacity-5"
            matSort matSortDisableClear>
            <div class="border py-8 text-center">
                No
            </div>

            <div [mat-sort-header]="'fieldLongName'"
                class="flex justify-center border py-4 my-custom-sort-header">
                Field
            </div>

            <div [mat-sort-header]="'platformLongName'" class="flex justify-center border py-4">
                Platform
            </div>

            <div [mat-sort-header]="'wellLongName'" class="flex justify-center border text-center py-4">
                Well
            </div>

            <div [mat-sort-header]="'stringShortName'" class="flex justify-center border text-center py-4">
                Well String
            </div>

            <div [mat-sort-header]="'stringIndicatorShortName'" class="flex border justify-center py-4">
                String Indicator
            </div>

            <div [mat-sort-header]="'prodStatus'" class="flex border justify-center py-4">
                Production Status
            </div>

            <div [mat-sort-header]="'activity'" class="flex border justify-center py-4">
                Activity Type
            </div>

            <div [mat-sort-header]="'recordDate'" class="flex border justify-center py-4">
                Activity Date
            </div>

            <div class="border flex justify-center items-center py-4">
                <div>THP {{ isPsi ? '(psi)' : '(kPa)'}}</div>

                <mat-icon svgIcon="autorenew" (click)="changeConversion()" class="ml-2 text-gray-300 cursor-pointer" [matTooltip]="isPsi ? 'Switch to kPa' : 'Switch to psi'"></mat-icon>
            </div>

            <div class="border  flex justify-center items-center ">
                <div class="text-center">Annulus Pressure Reading (PCP) {{ isPsi ? '(psi)' : '(kPa)'}} </div>

                <mat-icon svgIcon="autorenew" (click)="changeConversion()" class="mr-2 text-gray-300 cursor-pointer" [matTooltip]="isPsi ? 'Switch to kPa' : 'Switch to psi'"></mat-icon>
            </div>

            <div class="block border text-center py-8">
                Remarks
            </div>

            <div class="flex justify-center border text-center py-8">Action</div>
        </div>
        <!-- Rows -->
        <ng-container *ngIf="dt.rows.length; else noRecords">
            <ng-container *ngFor="let row of dt.rows; let i = index; trackBy: trackByFn;">
                <div class="table-annulus-pressure-pi-record-list-grid grid items-center border-b"
                    [ngClass]="{'bg-primary-100': i % 2 }">

                    <!-- No -->
                    <div class="py-4 text-center">
                        {{startingIndex + i + 1}}.
                    </div>

                    <!-- Field Long Name -->
                    <div class="flex truncate justify-center">
                        {{ row.fieldLongName }}
                    </div>

                    <!-- Platform Long Name  -->
                    <div class="flex justify-center">
                        {{ row.platformLongName }}
                    </div>

                    <!-- Well Long Name  -->
                    <div class="flex justify-center">
                        {{ row.wellLongName }}
                    </div>

                    <!-- String Short Name  -->
                    <div class="text-center">
                        {{ row.stringShortName }}
                    </div>

                    <!-- String Indicator -->
                    <div class="block text-center">
                        {{ row.stringIndicatorShortName }}
                    </div>

                    <!-- Production Status -->
                    <div class="block text-center">
                        {{ row.prodStatus }}
                    </div>

                    <!-- Activity -->
                    <div class="block text-center">
                        {{ row.activity }}
                    </div>

                    <!-- Activity Date -->
                    <div class="block text-center">
                        {{ handleFormatDate(row['recordDate'],true) }}
                    </div>

                    <!-- THP -->
                    <div class="block text-center">
                        {{ isPsi ? handleThpPhpValue(row['thpPsi'], row['isScanOffThp']) : handleThpPhpValue(row['thp'], row['isScanOffThp']) }}
                    </div>

                    <!-- Annulus Pressure Reading (PCP) -->
                    <div class="block text-center">
                        {{ isPsi ? handleThpPhpValue(row['annAPressPsi'], row['isScanOffPcp']) : handleThpPhpValue(row['annAPress'], row['isScanOffPcp']) }}
                    </div>

                    <!-- Remarks -->
                    <div class="block text-center">
                        {{ row.remarks || '-' }}
                    </div>

                    <!-- Action button -->
                    <div class="flex justify-center">
                        <button class="btn btn-remove-bg px-2" (click)="viewPiRecord(row)">
                            <mat-icon class="text-primary" [svgIcon]="'heroicons_solid:eye'" matTooltip="View"></mat-icon>
                        </button>

                        <button class="btn btn-remove-bg px-2" (click)="openHistoricalModal(row)">
                            <mat-icon class="text-primary" matTooltip="View Historical Records"
                                [svgIcon]="'heroicons_outline:document-chart-bar'"></mat-icon>
                        </button>
                    </div>
                </div>
            </ng-container>
        </ng-container>

        <ng-template #noRecords>
            <div class="p-8 sm:p-16 text-2xl sm:text-2xl font-semibold tracking-tight text-center">
                There are no Annulus Pressure Records registered!
            </div>
        </ng-template>
    </div>


    <div
        class="flex justify-between inset-x-0 bottom-0 border-b border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent">
            <div class="content-center px-3">
                {{ dt.page.totalRecords || 0 }} {{ dt.page.totalRecords <= 1 ? 'record' : 'records' }} 
            </div>

                <mat-paginator class="bg-gray-50" [ngClass]="{'pointer-events-none': isLoading}"
                    [length]="dt.page?.totalRecords" [pageIndex]="dt.page.offset" [pageSize]="dt.page.size"
                    [hidePageSize]="true" [showFirstLastButtons]="true">
                </mat-paginator>
        </div>
    </div>